import { Calculator } from 'lucide-react';
import { LocaleLink } from '@/components/LocaleLink';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

export const ActionLink = ({ to, children, ...props }) => (
  <Button asChild {...props}><LocaleLink to={to}>{children}</LocaleLink></Button>
);

export const Brand = ({ testId = 'site-brand', className, onClick }) => (
  <LocaleLink to="/" className={cn('brand-mark', className)} data-testid={testId} onClick={onClick}>
    <Calculator size={23} aria-hidden="true" /><span>ISMSCalculator</span>
  </LocaleLink>
);

export const PageHeader = ({ title, description, eyebrow, actions, compact = false, testId = 'page-title' }) => (
  <header className={cn('page-heading', compact && 'page-heading-compact')} data-testid={`${testId}-header`}>
    <div className="page-heading-copy">
      {eyebrow && <p className="data-eyebrow" data-testid={`${testId}-eyebrow`}>{eyebrow}</p>}
      <h1 data-testid={testId}>{title}</h1>
      {description && <p className="page-description" data-testid={`${testId}-description`}>{description}</p>}
    </div>
    {actions && <div className="page-actions" data-testid={`${testId}-actions`}>{actions}</div>}
  </header>
);

export const EmptyState = ({ title, description, icon: Icon, children, testId }) => (
  <section className="empty-state" data-testid={testId}>
    {Icon && <Icon size={28} aria-hidden="true" />}
    <h2 data-testid={`${testId}-title`}>{title}</h2>
    {description && <p data-testid={`${testId}-description`}>{description}</p>}
    {children && <div className="empty-state-action">{children}</div>}
  </section>
);